import type {RootState} from '@/state/store';

export const selectDeviceType = (state: RootState) => state.appSlice.deviceType;
export const selectTipsType = (state: RootState) => state.appSlice.tipsType;
export const selectInitialGuideItemType = (state: RootState) => state.appSlice.initialGuideItemType;
